import { styled, Typography } from '@mui/material';

export const ButtonText = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.grey[50],
}));
